<div class="breadcrumb">
  @for (breadcrumb of breadcrumbs; track breadcrumb.url + '-' + $index; let last = $last) {
  <div class="breadcrumb-item" [ngClass]="{ active: last }">
    @if (!last) {
    <a (click)="navigateTo(breadcrumb.url)">
      {{ breadcrumb.label | displayTranslation }}
    </a>
    } @if (last) {
    <div class="last-breadcrumb" [matTooltip]="breadcrumb.label | displayTranslation">
      {{ breadcrumb.label | displayTranslation }}
    </div>
    } @if (!last) {
    <div class="breadcrumb-separator">»</div>
    }
  </div>
  }
</div>
